import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { MerchantProfileView } from '../../merchant/api.js';
import type { WorkspaceCopy } from '../../merchant/copy.js';
import { Eyebrow } from '../../merchant/ui/primitives.js';
import { ResearchReferenceList } from './ResearchReferenceList.js';
import {
  contentLanguage,
  researchOutcome,
  researchUi,
} from './researchPresentation.js';

export function ProductionLineResearchResults({
  view,
  language,
  copy,
  lineId,
}: {
  readonly view: MerchantProfileView;
  readonly language: 'en' | 'ar';
  readonly copy: WorkspaceCopy;
  readonly lineId: string;
}): ReactNode {
  const ui = researchUi[language];
  const ideas = view.result?.recommendations ?? [];
  const outcome = researchOutcome(ideas);
  const locales = [
    ...new Set(ideas.map((idea) => contentLanguage(idea.outputLocale, language))),
  ];
  return (
    <section className="mj-ws-mt-20" aria-labelledby="research-results-title">
      <Eyebrow>{ui.complete}</Eyebrow>
      <h2 id="research-results-title" className="mj-ws-h2 mj-ws-mt-8">
        {ui[outcome]}
      </h2>
      <p className="mj-ws-muted mj-ws-sm">
        {outcome === 'business' ? ui.businessNote : ui.referencesNote}
      </p>
      <p className="mj-ws-sm">
        {ui.content}: {locales.join(' · ') || ui.unavailable}
      </p>
      <ResearchReferenceList ideas={ideas} copy={copy} language={language} />
      <p className="mj-ws-mt-20">
        <Link to={`/production-lines/${encodeURIComponent(lineId)}?step=idea`}>
          {ui.ideas} →
        </Link>
      </p>
    </section>
  );
}
